import { Ingredients } from "./Ingredients";

export class IProduct {
    _id: string;
    productId: string;
    name: string;
    category: string;
    description: string;
    quantity: number;
    soldQuantity: number;
    unitPrice: number;
    normalPrice: number;
    wholeSalePrice: number;
    code: string;
    discount: number;
    subTotal: number;
    barcode:string;
    SaleOrderProductLastQuantity: number;
    ingredients: Ingredients[];
    type:string;
    location: string;
    boxNumber: string;
    unit:string;
    shipped: boolean;
    returnDate: Date;
    discarded: boolean;
    restockDate: Date;
    totalQuantity: number;
    committedQuantity: number;
    gstOnProduct: number;
    orderNumber: string;
    status: string;
    vatTax: number;
    lastSoldPrice: number; //just to show in sale order grid
    cost: number; //purchase price of product
    isReturned: boolean;
    isNewItemInSaleOrder: boolean;
    isSaleOrderQuantityChange: boolean;
    baseQuatity:string;
    basePrice:number;
    constructor() {
        this.DateConverter();
    }
    DateConverter() {
        let date = new Date();
        this.restockDate = new Date(date.toLocaleDateString());
        this.returnDate = new Date(date.toLocaleDateString());
    }
}
